import { Box, Typography } from '@mui/material'
import React, { useMemo, useCallback } from 'react'
import styles from './CuratedList.module.scss'
import CuratedImage from './CuratedImage'

const MIN_VISIBLE = 6
const PLACEHOLDERS = ['/images/CuratedList.jpg']

function repeatToLength(arr, min) {
  if (!Array.isArray(arr)) return []
  if (arr.length === 0) return []
  const out = []
  while (out.length < min) {
    out.push(...arr)
  }
  return out.slice(0, Math.max(min, arr.length))
}

function CuratedListCard({ modalsOpen, images = [], guestView }) {
  const displayImages = useMemo(() => {
    const base = images.length ? images : PLACEHOLDERS
    return repeatToLength(base, MIN_VISIBLE)
  }, [images])

  const handleEditClick = useCallback(() => {
    modalsOpen?.()
  }, [modalsOpen])

  return (
    <Box className={styles.CuratedList}>
      <Box className={styles.CuratedListText}>
        <Typography variant="h2">Your Curated List</Typography>
      </Box>

      <Box className={styles.CuratedListImage}>
        {displayImages.map((src, i) => (
          <CuratedImage key={`${src}-${i}`} src={src} alt={`Curated ${i + 1}`} index={i} />
        ))}
      </Box>

      {!guestView && <Box className={styles.CuratedListButton}>
        <button onClick={handleEditClick}>
          Edit Preferences{' '}
          <img src="/images/arrow_back.svg" alt="" width="20" height="20" loading="lazy" />
        </button>
      </Box>}
    </Box>
  )
}

export default React.memo(CuratedListCard)
